import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "../../pages/loginPage/Login";
import Dashboard from "../../pages/dashBoard/Dashboard";
import StudentList from "../../pages/studentList/StudentList";
import SidebarPage from "../../pages/sideBar/SideBarPage";
import StudentRegistration from "../../pages/studentRegistration/StudenRegistration";
import AdminPage from "../../pages/adminPage/AdminPage";
import ClassBranchAdmin from "../../pages/adminPage/ClassBranchAdmin";
import FinancialPage from "../../pages/financialPage/FinancialPage";
import StudentDetails from "../../pages/studentDetails/StudentDetails";
import ExamRegistrationForm from "../../pages/examRegister/ExamRegistrationForm";
import ExamList from "../../pages/examList/ExamList";
import ProtectedRoute from "../ProtectedRoute";
import NotFound from "../../pages/NotFound";
import Forbidden from "../../pages/Forbidden";
import SidebarConditional from "../SidebarConditional";


function App() {
  return (
  
    <Router>
      <Routes>
      
        {/* Login sayfası */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        
        {/* Özel hata sayfaları */}
        <Route path="/forbidden" element={<Forbidden />} />
        
        {/* Sınav kayıt - herkese açık; admin kullanıcılarında sidebar gösterilir */}
        <Route
          path="/sinav-kayit"
          element={
            <SidebarConditional>
              <ExamRegistrationForm />
            </SidebarConditional>
          }
        />
        
        {/* Sadece admin'in erişebileceği sayfalar */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin']} redirectTo="/forbidden">
              <SidebarPage>
                <Dashboard />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/admin"
          element={
            <ProtectedRoute allowedRoles={['admin']} redirectTo="/forbidden">
              <SidebarPage>
                <AdminPage />
              </SidebarPage>
            </ProtectedRoute>
          }
        />

        <Route
          path="/class-branch-admin"
          element={
            <ProtectedRoute allowedRoles={['admin']} redirectTo="/forbidden">
              <SidebarPage>
                <ClassBranchAdmin />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        {/* Finansal sayfası - sadece admin */}
        <Route
          path="/financial"
          element={
            <ProtectedRoute allowedRoles={['admin']} redirectTo="/forbidden">
              <SidebarPage>
                <FinancialPage />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        {/* Öğrenci ödeme sayfası - student-details içinde zaten var olduğu için
            ayrı bir sayfa oluşturmaya gerek yok */}
        
        {/* Admin ve user'ın erişebileceği sayfalar */}
        <Route
          path="/student-list"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <SidebarPage>
                <StudentList />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/student-list/student-reg"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <SidebarPage>
                <StudentRegistration />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/student-list/student-details/:id"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <SidebarPage>
                <StudentDetails />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/exam-registered-list"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <SidebarPage>
                <ExamList />
              </SidebarPage>
            </ProtectedRoute>
          }
        />
        
        {/* 404 Not Found - Bilinmeyen tüm rotalar */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
